<div class="container">

  <div class="bn-li row">
    <div class="col">
      <h3>Cestas </h3>
    </div>

    <div class="col-auto" *ngIf="podeCadastrarTranche">
      <button class="btn btn-primary no-margin" type="button" [routerLink]="['/tranches']"
        ngbTooltip="Tela para cadastro de cesta."><i class="fa fa-file-signature">
        </i> Cadastrar Nova Cesta</button>
    </div>

  </div>

  <div class="table-responsive">
  <table class="table table-hover">
    <thead>
      <tr>
        <th id="col-numeroTranche" scope="col">
          <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'numeroTranche'" [nomeAtributoExibicao]="'Número da Cesta'"
            (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>

        <th id="col-dataInicioContratacao'" scope="col">
          <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataInicioContratacao'"
            [nomeAtributoExibicao]="'Data Início Contratação'" (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>
        <th id="col-dataFimContratacao" scope="col">
          <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataFimContratacao'"
            [nomeAtributoExibicao]="'Data Fim Contratação'" (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>
        <th id="col-dataInicioProtocolo" scope="col">
          <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataInicioProtocolo'"
            [nomeAtributoExibicao]="'Data Início Protocolo'" (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>
        <th id="col-dataFimProtocolo" scope="col">
          <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataFimProtocolo'"
            [nomeAtributoExibicao]="'Data Fim Protocolo'" (aoClickar)="mudancaOrdenacao($event)">
          </bn-ordenacao>
        </th>

      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let tranche of tranches" id="pointer" [routerLink]="['/tranches/', tranche.id]" >
        <td>{{tranche.numeroTranche}}</td>
        <td>{{tranche.dataInicioContratacao | date:'dd/MM/yyyy'}}</td>
        <td>{{tranche.dataFimContratacao | date:'dd/MM/yyyy' }}</td>
        <td>{{tranche.dataInicioProtocolo | date:'dd/MM/yyyy' }}</td>
        <td>{{tranche.dataFimProtocolo | date:'dd/MM/yyyy' }}</td>
      </tr>
    </tbody>

  </table>
  </div>

</div>
